import * as React from "react";
import { useIntercom } from "react-use-intercom";
import { useFlightPathUser } from "../../../core/auth_insight/UserContext";
import { IIntercomLiveChatProps } from "./IntercomLiveChat";
import { Button, ButtonTypes } from "../../../components/ui/Button";
import I18n from "../../../core/localization/I18n";
import { Enums, UiSizes } from "../../../enums";
import { Icon, IconSymbols } from "../../../components/ui/Icon";

const IntercomLiveChatButton: React.FunctionComponent<IIntercomLiveChatProps> = props => {
  const { boot, show } = useIntercom();
  const user = useFlightPathUser();
  const environment = appConfig.appEnvironment;

  const bootWithProps = React.useCallback(() => {
    boot({
      userId: user.sub,
      name: user.firstName,
      email: user.email,
      hideDefaultLauncher: true,
      customAttributes: {
        organisation: props.currentOrganisationName,
        organisationId: props.currentOrganisationId,
        environment: environment
      }
    });
  }, [
    boot,
    user.firstName,
    user.email,
    user.sub,
    props.currentOrganisationId,
    props.currentOrganisationName,
    environment
  ]);

  React.useEffect(() => {
    bootWithProps();
  }, [bootWithProps]);

  return (
    <>
      {props.showAsButton === "button" && (
        <Button id="IntercomChatTrigger" type={ButtonTypes.LINK} size={Enums.UiSizes.XS} onClick={() => show()}>
          {I18n.t("phrases.chatWithMember")}
        </Button>
      )}
      {props.showAsButton === "icon-label" && (
        <div className="d-flex flex-row align-items-center c-pointer" onClick={() => show()}>
          <Icon className="flex-column mr-1" symbol={IconSymbols.MessageSquare} size={UiSizes.MD} />{" "}
          <span className="flex-column">{I18n.t("phrases.chatWithMember")}</span>
        </div>
      )}
      {props.showAsButton === "icon" && (
        <div className="d-flex c-pointer" onClick={() => show()}>
          <Icon className="mx-1" symbol={IconSymbols.MessageSquare} size={UiSizes.MD} />
        </div>
      )}
    </>
  );
};

export default IntercomLiveChatButton;
